<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 *ngIf="form.get('name').value"
            class="headline m-0 flex-auto">{{ form.get('name').value }}</h2>
        <h2 *ngIf="!form.get('name').value"
            class="headline m-0 flex-auto">Nuevo Origen</h2>
    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Nombre</mat-label>
                <input cdkFocusInitial formControlName="name" matInput required>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:place"></mat-icon>
                <mat-error *ngIf="form.get('name')?.hasError('required')">
                    El nombre es requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-slide-toggle formControlName="active" color="primary">
                Activo
            </mat-slide-toggle>
        </div>
    </mat-dialog-content>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()">Cancelar</button>
        <button mat-button color="primary" type="submit" [disabled]="!form.valid">
            {{ mode === 'create' ? 'Crear' : 'Actualizar' }}
        </button>
    </mat-dialog-actions>
</form>

